import { render, staticRenderFns } from "./addUpdateRoles.vue?vue&type=template&id=542ea1e0"
import script from "./addUpdateRoles.vue?vue&type=script&lang=js"
export * from "./addUpdateRoles.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports